export default __webpack_public_path__ + "static/swvl-5-cc482c4f456e91217b3be4ec7bc434ec.webp";